// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWarning_container__U7bqV","warning":"PageWarning_warning__ag_vE","whiteBg":"PageWarning_whiteBg__KjIWj"};